import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChipSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chip-simple, processor"} maskId="square-filled-radius-0-stroke-1-IconChipSimple"><path d="M15 15H9V9H15V15Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M10 3H14V1H15V3H21V9H23V10H21V14H23V15H21V21H15V23H14V21H10V23H9V21H3V15H1V14H3V10H1V9H3V3H9V1H10V3ZM8 16H16V8H8V16Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChipSimple;
